import { LocationDescriptorObject, LocationState, Path } from 'history';

const GO_BACK_OR_REPLACE = '@navigation/GO_BACK_OR_REPLACE' as const;

const goBackOrReplace = (replaceUrl: LocationDescriptorObject<LocationState> | Path, forceReplace?: boolean) => ({
  type: GO_BACK_OR_REPLACE,
  payload: { replaceUrl, forceReplace },
});
goBackOrReplace.type = GO_BACK_OR_REPLACE;

const actions = {
  goBackOrReplace,
};

export default actions;
